import { Box, Button, useMediaQuery } from '@mui/material';

import { useState } from 'react';
import { Link } from 'react-router-dom';

import MobileDrawer from './MobileDrawer';
import TopNav from './TopNav';

import codemeta from '../../assets/codemeta.svg';
import logo from '../../assets/logo.svg';

import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobileView = useMediaQuery('(max-width: 750px)');

  return (
    <Box
      sx={{
        minHeight: '94px',
        maxWidth: '1800px',
        width: '85%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '@media screen and (max-width: 750px)': {
          position: 'fixed',
          width: '100%',
          backgroundColor: 'white',
          zIndex: 1201,
          left: 0,
        },
      }}
    >
      {isMobileView ? (
        <>
          <Button
            onClick={() => setIsOpen((state) => !state)}
            aria-label="Hauptmenü"
            sx={{
              padding: 0,
              margin: 0,
              minWidth: 0,
              position: 'absolute',
              left: '40px',
              zIndex: 1201,
            }}
          >
            {isOpen ? (
              <MenuOpenOutlinedIcon
                sx={{ fontSize: '30px', color: '#C8C8C8', cursor: 'pointer' }}
              />
            ) : (
              <MenuOutlinedIcon sx={{ fontSize: '30px', color: '#C8C8C8' }} />
            )}
          </Button>

          <Box
            sx={{
              justifySelf: 'center',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={logo}
              // eslint-disable-next-line react/no-unknown-property
              fetchpriority="high"
              style={{
                height: '32px',
              }}
              alt="Codemeta Logo"
            />

            <img
              src={codemeta}
              style={{
                height: '22px',
                marginLeft: '15px',
              }}
              alt="Codemeta"
            />
          </Box>

          <MobileDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
      ) : (
        <>
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={logo}
              style={{
                height: '32px',
              }}
              alt="Codemeta Logo"
            />

            <img
              src={codemeta}
              style={{
                height: '22px',
                marginLeft: '15px',
              }}
              alt="Codemeta"
            />
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          <TopNav />
        </>
      )}
    </Box>
  );
}
